import { ValueWithCopyButton } from '../../../common/ValueWithCopyButton';
import { useCreatedIntegrations } from '../partnerIntegrationSlice';

export const CreatedIntegrationsTable = () => {
    const createdIntegrations = useCreatedIntegrations();

    return (
        <table className='table table-hover'>
            <thead>
                <tr>
                    <th>Time</th>
                    <th>Integration-ID</th>
                    <th>Client-ID</th>
                    <th>Account</th>
                </tr>
            </thead>
            <tbody>
                {createdIntegrations.map(integration => (
                    <tr key={integration.integrationId} data-cy={'created-partner-integrations-table-row'}>
                        <td>{integration.timestamp}</td>
                        <td>
                            <ValueWithCopyButton value={integration.integrationId} fieldName={'Integration-ID'} />
                        </td>
                        <td>{integration.clientId}</td>
                        <td>
                            {integration.accountName} ({integration.accountId})
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
